import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import Unauthorized from '../../pages/SessionExpired';
import { findItemByValueRecursively } from '../../components/Layout/CommonService';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'types/types';
import { setActiveView, setOpenedViews } from 'features/applicationState';
import UserManager from 'utils/UserManager';
import { isSwitchable } from 'utils/Utils';

const ProtectedRoute = () => {
  const appState = useSelector((state: RootState) => state.applicationState);
  const dispatch = useDispatch();
  const { viewId, dashboardId } = useParams();
  let id = location.hash.substring(location.hash.lastIndexOf('/') + 1);
  id = id.includes('?') ? id.substring(0, id.indexOf('?')) : id;
  useEffect(() => {
    //id will be viewId param in case of kendo views and dashboardId for react dashboards
    const idToUse = viewId || dashboardId || id;
    const setView = () => {
      const view = findItemByValueRecursively(
        idToUse?.toString() || '',
        appState.sidebarItems
      );
      if (view) {
        if (!UserManager.hasPermission(view.permissions)) {
          return;
        }
        dispatch(setActiveView(view));
      }
      return view;
    };

    //if the given viewId is not part of opened views 
    if (!appState.openedViews.some((_) => _.value === idToUse)) {
      const view = setView(); 
      if (view && isSwitchable(view)) {
        dispatch(setOpenedViews([...appState.openedViews, view]));
      }
    } else if (appState.activeView.value != idToUse) {
      setView();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, viewId, dashboardId, id]);

  const view = findItemByValueRecursively(
    viewId || dashboardId || '',
    appState.sidebarItems
  );
  if (view && !UserManager.hasPermission(view.permissions)) {
    return <Unauthorized />;
  }
  return <Outlet />;
};
export default ProtectedRoute;
